import React from 'react';
import LoadingSpinner from './loadingSpinner'
import C18Input00 from './C18Input00'
import C18Select00 from './C18Select00'
import C18Select01 from './C18Select01'
import C18SiteZoneSub00 from './C18SiteZoneSub00'
import C18Button00 from './C18Button00'
import {wsTrans,constant} from '../utils/utils'
import {loadSitesInfo,loadZonesInfo, loadSubscriptionInfo, getZoneIndex,loadSiteData,getZoneInfo, onCheckout, 
  addToAdminLog, updateSubscription, getRecurlyAccount, getZonesCount, getZoneDiscount, getTotal, getLockedZones, getZoneCount,acctFeature,loadGatewaysInfo,getGatewayInfo,
  privs
} from './C18utils'
import {sendArray, dbVals, putZValue} from '../../components/utils/http';
import {cl, globs, getTime, allZones, allAddons, capitalize, round, zoneTypes, recurlySubdomain,getRandomString,getTimeI} from '../../components/utils/utils';
import {setClientId} from '../../components/utils/ws'
import history from "../../history"

class C18ManageZones extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      zoneAddName:"",
      zoneType:"link4",
      loaded:false,
      mzSite:-1,
    }
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.saveZones)
    this.props.parms.onChange({cmd:"savePage", data:{savePage:true}})
    this.loadInfo()
    this.setBreadCrumbs()
  }
  
  setBreadCrumbs=()=>{
    if(this.props.parms){
      this.props.parms.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:"Admin", url:`/usa/c18/admin`},
              {t:"Manage Zones", url:`/usa/c18/admin/manageZones2`},
            ]},
        },
      )
    }
  }

  componentWillUnmount=()=>{
    this.subscribe_savePageEvent.remove()
  }
  
  loadInfo=async()=>{
    await loadSitesInfo()
    await loadZonesInfo()
//     cl(globs.zonesInfo)
    await loadGatewaysInfo()
    let sub = globs.subscriptionInfo.info
    // this.saveZoneNames(false)// save the names to compare later
//     cl("load info")
    this.saveZoneInfo(false)// save the names to compare later
    let siteSel=globs.sitesInfo.info[0].siteId
    let zoneSel=this.getZoneSel(siteSel)
    this.setState({loaded:true, siteSel:siteSel,mzSite:siteSel,zoneSel:zoneSel,
      oldPlan: sub,
      currPlan: JSON.parse(JSON.stringify(sub)), displayCheckout: false, subChange: false, unlockAllZones: false, newConfig: []})
  }

  onCancel = () => {
    // TODO un-disable outside controls
    globs.events.publish("savePageEnable",true)
    this.mySetState({displayCheckout:false})
//     this.mySetState({displayCheckout: false, plan: null, preview: null, currPlan: JSON.parse(JSON.stringify(this.state.oldPlan)),
//       unlockedAllZones: [], unlockAllZones: false, newConfig: []})
  }
  
  showSitesOpts=()=>{
    return globs.sitesInfo.info.map((s,i)=>{
      return(
        <option key={i} value={s.siteId}>{s.name}</option>
      )
    })
  }

  showZonesOpts=()=>{
    let gzi=globs.zonesInfo.info.slice(0)
    gzi=gzi.sort((a,b)=>{
      if(a.zoneName<b.zoneName){return -1}
      if(a.zoneName>b.zoneName){return 1}
      return 0
    })
//     cl(gzi)


//     cl(gzi)
    return gzi.map((z,i)=>{
      if(z.siteId==this.state.siteSel){
//         cl(z)
        return(
          <option key={i} value={z.zoneId}>{z.zoneName||"(No Name)"}</option>
        )
      }
    })
  }

  saveToAdminLog=(adds,o,n)=>{
//     cl(o)
//     cl(n)
    let addObj={
      userId:globs.userData.session.userId,
      siteId:o.siteId,
      zoneId:o.zoneId,
      time:Math.floor(getTime())
    }
    if(o.zoneName!=n.zoneName){
      adds.push(
        Object.assign({},addObj,
        {
        action:"zoneName",
        oldVal:o.zoneName,
        newVal:n.zoneName,
      }))
    }
    if(o.hideEquipment!=n.hideEquipment){
      adds.push(
        Object.assign({},addObj,
        {
        action:"hideEquipment",
        oldVal:o.hideEquipment,
        newVal:n.hideEquipment,
      }))
    }
  }

  saveZoneInfoToDb=async(data)=>{
//     cl(data)
    await wsTrans("usa", {cmd: "cRest", uri: "/s/zones", method: "update", 
      sessionId: globs.userData.session.sessionId, body: data})
    globs.events.publish("saveOK",true)
//     cl("save zone")
  }

  saveZoneName800=(zone,zoneName)=>{
    cl("saveZoneName800")
    let body1={
      siteId:zone.siteId,
      controllerId:zone.controllerId,
      zoneId:zone.zoneId,
      siteZoneIndex:zone.siteZoneIndex,
      controllerName:zoneName,
      virtual:zone.virtual
    }
    cl(`zcStatus: write 800 zoneName: ${body1.controllerName}`)
    wsTrans("usa", {cmd: "cRest", uri: "/s/iGrow800Controller", method: "update",
      sessionId: globs.userData.session.sessionId, body: body1})
  }
  
//   saveZoneNameToDb=async(zone,zoneId, zoneName)=>{
//     cl("save zone name")
//     if(zone.gatewayType==800){this.saveZoneName800(zone,zoneName)}
//     await wsTrans("usa", {cmd: "cRest", uri: "/s/zones", method: "update",
//       sessionId: globs.userData.session.sessionId, body: {
//         zoneId: zoneId,
//         zoneName: zoneName,
//       }})
//     globs.events.publish("saveOK",true)
//   }

  restoreOldZoneName=async()=>{
    let st=this.state
    cl("restore zone")
    globs.zonesInfo={}
    await loadZonesInfo()
    this.setState({upd:(st.upd||0)+1})
  }

  saveZoneNameToControllerDb=async(zone,zoneName)=>{// z=gatewayZoneInd, c=255, i=5022 is zone name
//     cl("save name to controller db")
// need to load site data!  
//     cl(zone)
    cl("save zone name")
//     cl(zoneName)
    if(zone.gatewayType==800){return this.saveZoneName800(zone,zoneName)}
//     await loadSiteData(zone.siteId)
//     cl(zone, zoneName)
    let pid=5022 // zone name
    let z=zone.siteZoneIndex
    let c=255
    let parms=[]
    putZValue(z,c,pid,zoneName)
//     if(){
    parms.push({
      c:c,
      d:zoneName,
      f:1,
      i:pid,//iOfs+ofs,
      t:Math.floor(getTime()),
      z:z,
    })
//     }
    cl(parms)
    if(!zone.virtual){
      let failTO=setTimeout(this.restoreOldZoneName,10000)// matches SaveHeader
      cl(parms)
      let res=await sendArray(parms)
      clearTimeout(failTO)
      cl(res)
    }
//     cl(res)
//     .then(r=>{})
    globs.events.publish("saveOK",true)
//     cl("save OK")
  }

  saveZoneInfo=async(doSave)=>{// do Save, means save to db, not means copy current settings , newPlan means new plan will be created on recurly
//     cl("save zone")
//     cl(this.state)
    let st=this.state
    if(!doSave){
      this.zoneNames=[]
      this.hideEquipment=[]
      this.doserZone=[]
    }
//     cl(this.zoneNames)
    let gzi=globs.zonesInfo.info
    let adminAdds=[]
    for(let i=0;i<gzi.length;i++){
      if(doSave){
        let zoneNew = {zoneId: gzi[i].zoneId,doserZone:gzi[i].doserZone}
        let zoneOld = {doserZone:this.doserZone[i]}
        let zoneChange = false
        if(
          ((this.zoneNames[i]!=gzi[i].zoneName)||
            (zoneNew.doserZone||false)!=(zoneOld.doserZone||false)||
            (gzi[i].zoneId==st.zoneSel))&&
          (gzi[i].siteId==st.siteSel)
        ){// always save current zoneName
//           cl(gzi[i])
          if(!gzi[i].zoneName){
            gzi[i].zoneName=`Zone ${gzi[i].siteZoneIndex+1}`
          }
//           cl(`update ${gzi[i].zoneName}`)
// this is a little deceiving. zoneNames is what the names *used* to be
//           cl("save zone name")
//           cl(this.zoneNames[i],gzi[i].zoneName)
          zoneNew.zoneName = gzi[i].zoneName // was this.zoneNames[i]
          zoneOld.zoneName = this.zoneNames[i]
//           cl(zoneNew)
//           cl(zoneOld)
//           cl(zoneNew)
          if(zoneNew.zoneName!=zoneOld.zoneName){
            cl(`old: ${zoneOld.zoneName}, new: ${zoneNew.zoneName}`)
            await this.saveZoneNameToControllerDb(gzi[i],gzi[i].zoneName)
          }
          zoneChange = true
        }
        if (this.hideEquipment[i]!=(gzi[i].hideEquipment||false)){
          zoneNew.hideEquipment = gzi[i].hideEquipment
          zoneOld.hideEquipment = this.hideEquipment[i]
          zoneChange = true
        }
        if (zoneChange&&(gzi[i].siteId==st.siteSel)) {
//           cl("save zone info")
//           cl(zoneNew)
//           cl(i,st.siteSel)
//           cl(gzi[i])
//           cl(zoneNew)
          await this.saveZoneInfoToDb(zoneNew)
          this.saveToAdminLog(adminAdds, zoneOld, gzi[i])
        }
      }else{
        this.zoneNames.push(gzi[i].zoneName)
        this.hideEquipment.push(gzi[i].hideEquipment||false)
        this.doserZone.push(gzi[i].doserZone||false)
      }
//       if(gzi[i].siteId==siteId){
//         return gzi[i].zoneId
//       }
    }
//     cl(adminAdds)
//     cl("save zone")
    if(doSave){addToAdminLog(adminAdds)}
//     cl(this.zoneNames)
  }
  
// this is obsolete
//   saveZoneNames=(doSave)=>{// do Save, means save to db, not means copy current settings
// // this is not being used!
//     if(!doSave){this.zoneNames=[]}
//     cl("save zone names")
//     let gzi=globs.zonesInfo.info
//     let adminAdds=[]
//     for(let i=0;i<gzi.length;i++){
//       if(doSave){
//         if(this.zoneNames[i]!=gzi[i].zoneName){
//           // cl(`update ${gzi[i].zoneName}`)
//           this.saveToAdminLog(adminAdds, {zoneName: this.zoneNames[i]}, gzi[i])
//           // cl(gzi[i])
// //           cl("save zone names")
//           this.saveZoneNameToDb(gzi[i],gzi[i].zoneId,gzi[i].zoneName)
//           this.saveZoneNameToControllerDb(gzi[i],gzi[i].zoneName)
//         }
//       }else{
//         this.zoneNames.push(gzi[i].zoneName)
//       }
// //       if(gzi[i].siteId==siteId){
// //         return gzi[i].zoneId
// //       }
//     }
// //     cl(adminAdds)
//     if(doSave){addToAdminLog(adminAdds)}
// //     cl(this.zoneNames)
//   }
  
  getZoneSel=(siteId)=>{
    let gzi=globs.zonesInfo.info
    for(let i=0;i<gzi.length;i++){
      if(gzi[i].siteId==siteId){
        return gzi[i].zoneId
      }
    }
  }

  saveZones=async(cmd)=>{
//     cl("saveZones")
    if(cmd=="save"){
      await this.saveZoneInfo(true)// save to db
      globs.events.publish("saveOK",true)
      // this.saveZoneNames(true)// save to db
    }
  }
  
  setZoneName=(zoneId,zoneName)=>{// should not be changing zonesInfo!
    let gzi=globs.zonesInfo.info
    for(let i=0;i<gzi.length;i++){
      if(gzi[i].zoneId==zoneId){
        gzi[i].zoneName=zoneName
        return
      }
    }
  }

  setHideZoneEquipment=(zoneId,hideEquipment)=>{// should not be changing zonesInfo!
    let gzi=globs.zonesInfo.info
    for(let i=0;i<gzi.length;i++){
      if(gzi[i].zoneId==zoneId){
        gzi[i].hideEquipment=hideEquipment
        return
      }
    }
  }

  deleteZone=async(zoneId)=>{// should not be changing zonesInfo! why not?
    let zone=globs.zonesInfo.info.filter(z=>{return z.zoneId==zoneId})[0]
//     cl(zone)
    let res=await this.props.parms.getPopup({text:"Are you sure you want to delete this Zone?", buttons:["Cancel","Yes"]})
    if(res=="Yes"){
      wsTrans("usa", {cmd: "cRest", uri: "/s/zones", method: "delete", 
        sessionId: globs.userData.session.sessionId,
        body: {zoneId: zoneId,virtual:zone.virtual, siteId:zone.siteId,
          siteZoneIndex:zone.siteZoneIndex}})
      let ind=getZoneIndex(zoneId)// delete from zonesInfo
      globs.zonesInfo.info.splice(ind,1)
      this.mySetState({update:(this.state.updated||0)+1,
        zoneSel:this.getZoneSel(this.state.siteSel)
      })
    }
  }

  addZone=async()=>{
//     cl("add zone")
//     cl(this.state)
    let st=this.state
    let siteZones=globs.zonesInfo.info.filter(zo=>{return zo.siteId==st.siteSel})
    let inds={}
    siteZones.forEach(z=>{inds[z.siteZoneIndex]=1})
    var siteZoneIndex
    for(let i=0;i<200/*40*/;i++){// find unused siteZoneIndex
      if(!inds[i]){siteZoneIndex=i; break}
    }
    let gwType={pearl:1900,iGrow800:800,hydroroot16:1900}[st.zoneType]||1800
    cl(gwType)
    let zone={
      siteId:st.siteSel,
      zoneId:getRandomString(16),
      zoneName:this.state.zoneAddName,
      gatewayType:gwType,//1800,
      siteZoneIndex:siteZoneIndex,
      inNet:false,
      virtual:true,
      virtualType:st.zoneType,
      zoneTier:zoneTypes["locked"],
      ...(st.zoneType==="hydroroot16"?{gatewaySubType:"HydroR"}:{}),
    }
    cl(zone)
    globs.zonesInfo.info.push(zone)
    await this.saveZoneNameToControllerDb(zone,zone.zoneName)

//     cl(globs.zonesInfo)
// create the zones entry:
    wsTrans("usa", {cmd: "cRest", uri: "/s/zones", method: "create",
      sessionId: globs.userData.session.sessionId, body: zone})
    let configId=""
    var resp
    let vTemp=`VirtualZoneTemplate_${st.zoneType}`
    cl(vTemp)
// get the configId from the virtual name
    resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/zoneConfig", method: "retrieve",
      sessionId: globs.userData.session.sessionId, body: {vTemp:vTemp}})
    cl(resp)
    let zTemp=resp.data[0]
    cl(zTemp)
//       cl("restore")
      let query={
        configId:zTemp?.configId,
        siteId:globs.userData.session.siteId,
        zoneInd:siteZoneIndex,
        virtual:true,
        ranges:[[0,100000]]}
//       cl(query)
// write the template config to the new zone:
      resp=await wsTrans("usa", {cmd: "cRest", uri: "/s/zoneConfig", method: "update",
        sessionId: globs.userData.session.sessionId, body: query})
//     }
//     cl(st.update)
    this.setState({update:(st.update||0)+1})
//     cl(st)
  }
  
  mySetState=(vals)=>{
    this.setState(vals)
  }
  
  onChange=async(type,vals)=>{
//     cl(type,vals)
    let st=this.state
    switch(type){
      case "upd":
//         cl(type)
        this.setState(vals)
        break
      case "siteSel":
        Object.assign(vals,{zoneSel:this.getZoneSel(vals.siteSel),mzSite:vals.siteSel})
        await loadSiteData(vals.siteSel)

      case "zoneAddName":
      case "zoneSel":
//         cl(vals)
        setClientId(vals.zoneSel)
        this.mySetState(vals)
        break
      case "siteZone":
//         cl(vals)
        this.mySetState({zoneSel:vals.zoneId})
        break
      case "zoneName":
        globs.events.publish("savePageEnable",true)
        if(!vals.zoneName){
          this.setZNTO=setTimeout(e=>{
            let zo=globs.zonesInfo.info.filter(z=>{
              return z.zoneId==st.zoneSel})[0]
            vals.zoneName=`Zone ${zo.siteZoneIndex+1}`
            this.setZoneName(this.state.zoneSel,vals.zoneName)
            this.setState(vals)
//             globs.events.publish("savePageEnable",true)
          },5000)
        }else{
          clearTimeout(this.setZNTO)
        }
//         cl(st)
        this.setZoneName(this.state.zoneSel,vals.zoneName.substring(0,19))
        this.mySetState(vals)
        break
      case "doserZone":
        globs.events.publish("savePageEnable",true)
        let zi=globs.zonesInfo.info.filter(z=>z.zoneId==this.state.zoneSel)[0]
        Object.assign(zi,vals)
        this.mySetState(vals)
        break
      case "hideZoneEquipments":
        globs.events.publish("savePageEnable",true)
        this.setHideZoneEquipment(this.state.zoneSel,vals.hideEquipment)
        this.mySetState(vals)
        break
      case "deleteZone":
//         cl("del")
        this.deleteZone(this.state.zoneSel)
        break
      case "moveZone":
        return this.moveZone()
      case "addZone":
        this.addZone();
        break
      default:
        this.setState(vals)
        break
    }
  }
  
//   showSelectSite=()=>{
// //     cl(this.state.siteSel)
//     return (
//       <div className="custom-select">
//         <label htmlFor="">Select Site</label>
//         <C18Select00 id=""
//           value={this.state.siteSel}
//           onChange={e=>this.onChange("siteSel",{siteSel: e.currentTarget.value})}
//         >
//           {this.showSitesOpts()}
//         </C18Select00>
//         <span className="material-icons down-arrow">
//           keyboard_arrow_down
//         </span>
//       </div> 
//     )
//   }
  
//   showSelectZone=()=>{
//     return(
//       <div className="custom-select">
//         <label htmlFor="">Select Zone</label>
//         <C18Select00
//           value={this.state.zoneSel}
//           onChange={e=>this.onChange("zoneSel",{zoneSel: e.currentTarget.value})}
//         id="">
//         {this.showZonesOpts()}
//         </C18Select00>
//         <span className="material-icons down-arrow">
//           keyboard_arrow_down
//         </span>
//       </div>
//     )
//   }
//
  showSelectZone=()=>{
    return(
      <div className="custom-select">
        <label htmlFor="">Select Zone</label>
        
        <C18Select00 id=""
          parms={{list:true}}
          value={this.state.zoneSel}
          onChange={e=>this.onChange("zoneSel",{zoneSel: e.currentTarget.value})}
        >
          {this.showZonesOpts()}
        </C18Select00>
        {false&&
          <span className="material-icons down-arrow">
            keyboard_arrow_down
          </span>
        }
      </div> 
    )
  }
  
  showSelectSite=()=>{
    return(
      <div className="custom-select">
        <label htmlFor="">Select Site</label>
        
        <C18Select00 id=""
          parms={{list:true}}
          value={this.state.siteSel}
          onChange={e=>this.onChange("siteSel",{siteSel: e.currentTarget.value})}
        >
          {this.showSitesOpts()}
        </C18Select00>
        {false&&
          <span className="material-icons down-arrow">
            keyboard_arrow_down
          </span>
        }
      </div> 
    )
  }
  
  showSelectZoneType=()=>{
    let types=[
    {v:"link4",t:"1800-Link 4"},
    {v:"iDoser",t:"1800-iDoser"},
    {v:"modbus",t:"1800-Modbus"},
    {v:"expLink4",t:"1800-Expanded Link 4"},
    {v:"pearl",t:"Pearl"},
    {v:"iGrow800",t:"iGrow 800"},
    {v:"hydroroot16",t:"HydroRoot 16"},
    ]
    return(
      <C18Select01 parms={{
        label:"Zone Types",
        zoneType:this.state.zoneType,
        valueName:"zoneType",
        opts:types,
        onChange:this.onChange,
      }}/>
    )
  }

  moveZone=async()=>{
    let st=this.state
    let zo=globs.zonesInfo.info.filter(z=>{return z.zoneId==st.zoneSel})[0]
    let si=globs.sitesInfo.info.filter(s=>{return s.siteId==st.siteSel})[0]
    let smz=globs.sitesInfo.info.filter(s=>{return s.siteId==st.mzSite})[0]
//     cl(st.mzSite)
    let res=await this.props.parms.getPopup({text:`This will move the zone ${zo.zoneName} to the site ${smz.name}. All current historical data for this zone will be lost. Do you want to move this Zone?`, buttons:["Cancel","Yes"]})
    if(res=="Yes"){
      let zone=globs.zonesInfo.info.filter(z=>{return z.zoneId==st.zoneSel})[0]
      zone.siteId=st.mzSite
      await wsTrans("usa", {cmd: "cRest", uri: "/s/zones", method: "update",
        sessionId: globs.userData.session.sessionId, body: {
          zoneId: st.zoneSel,
          siteId:st.mzSite,
        }})
      this.setState({upd:(st.upd||0)+1})
    }
  }

  showMoveZone=()=>{
    let st=this.state
    let zo=globs.zonesInfo.info.filter(z=>{return z.zoneId==st.zoneSel})[0]
//     cl(zo)
    if(!zo){return}
    let gw=globs.gatewaysInfo.info.filter(g=>{return g.gatewayId==zo.gatewayId})[0]
    if(!gw&&(zo.gatewayType==800)){gw={gatewayType:zo.gatewayType}}
    let opts=globs.sitesInfo.info
      .map(s=>{return{v:s.siteId,t:s.name}})
      .filter(s=>{return s.v&&(s.t!="")})
    opts.sort((a,b)=>{
      if(a.t.toLowerCase()<b.t.toLowerCase()){return -1}
      if(a.t.toLowerCase()>b.t.toLowerCase()){return 1}
      return 0
    })
    opts.unshift({v:-1,t:"Select a Site"})
    let si=globs.sitesInfo.info.filter(s=>{return s.siteId==st.mzSite})[0]
//     cl(gw?.gatewayType)
//     cl(zo.siteId,st.mzSite)
//     cl(si)
//     cl(zo)
//     cl(st)
//     cl()
    return(
      <div className="custom-select" style={{borderStyle:"solid",borderWidth:1,
        borderRadius:10,padding:"0px 20px"}}>
        <p>Move {zo.zoneName} to a Different Site</p>
        <C18Select01 parms={{
          label:"Select Site to Move To",
          valueName:"mzSite",
          mzSite:(st.mzSite||""),
          opts:opts,
          onChange:(e,v)=>{this.onChange("mzSite",v)}//this.onChange,
        }}/>
        <C18Button00 type="button" className="filled"
          disabled={(![800,1900].includes(gw?.gatewayType))||(zo.siteId==st.mzSite)}
          onClick={e=>{this.onChange("moveZone")}}
        >Move Zone</C18Button00><br/>
      </div>
    )
  }
  
  showAddZone=()=>{
    return(
      <div className="custom-select" style={{borderStyle:"solid",borderWidth:1,
        borderRadius:10,padding:"0px 20px"}}>
        <p>Add Virtual Zone</p>
        {this.showSelectZoneType()}
        <label htmlFor="zone-name">Zone Name</label>
        <C18Input00 type="text" id="zone-add-name" className="with-right-button" 
          value={this.state.zoneAddName}
          onChange={e=>this.onChange("zoneAddName",{zoneAddName:e.currentTarget.value})}
        />
        <C18Button00 type="button" className="outlined"
        disabled={!this.state.zoneAddName}
          onClick={e=>this.onChange("addZone")}>Add Zone</C18Button00>
      </div>
    )
  }
  
  render(){
//     cl("render")
    if(this.state.loaded){
//       cl(this.state.zoneSel)
    let zoneInfo=getZoneInfo(this.state.zoneSel)
//     let gw=globs.gatewaysInfo.info.filter(g=>{return g.gatewayId==zoneInfo.gatewayId})
//     zoneInfo.clientId=gw.clientId
    let gw=globs.gatewaysInfo.info.filter(gw=>{
//       cl(gw)
      return gw.gatewayId==zoneInfo?.gatewayId})[0]
    if(!gw){gw={}}
//     cl(gw)
    var lastContact,lcTime
    if(gw?.updateTime){
      lcTime=getTimeI()-gw.updateTime
      if(gw.connected){
        lastContact=<div>{`Last Contact: ${lcTime} seconds ago`}</div>
      }else{
        lastContact=(
          <div style={{color:"red"}}>Not Connected</div>
        )
      }
    }
    let current=getTimeI()-zoneInfo?.updateTime<86400
//     cl(current)
    let gatewayInfo=getGatewayInfo(zoneInfo?.gatewayId)
//     let inNet=zoneInfo?.inNet||0
    let virtual=zoneInfo?.virtual||false
    let isSu=privs("super","",constant.AREA_PRIVS_READ)

//     let inNet=globs.zonesInfo.info[getZoneIndex(this.state?.zoneSel)]?.inNet
//             {this.showSelectZoneTier(zoneInfo)}
    return(
      <div>
        {this.showSelectSite()}
        <div className="clearfloat"></div>
        {this.showSelectZone()}
        {zoneInfo&&
          <>
            <div>Gateway Name: {gatewayInfo ? gatewayInfo.name :"" }</div>
            <div>Gateway ID: {zoneInfo.gatewayId}</div>
            <div>Client ID: {gw.clientId}</div>
            <div>Zone Index: {zoneInfo.siteZoneIndex+1}</div>
            <div>Zone ID: {zoneInfo.zoneId}</div>
            {lastContact}
            <div>Firmware Version: {gw?.fwVersion}</div><br/>
            <label htmlFor="zone-name">Zone Name (19 characters max)</label>
            <C18Input00 type="text" id="zone-name" 
              value={zoneInfo.zoneName||""}
              onChange={e=>this.onChange("zoneName",{zoneName:e.currentTarget.value})}
            />
            <h3>Options</h3>
            <div className="checkbox-field float-left-box" style={{float:'none'}}>
              <div className="top-margin">
                <input type="checkbox" id="schedule-status" checked={zoneInfo?.hideEquipment||false}
                  onChange={()=>this.onChange("hideZoneEquipments", {hideEquipment:!zoneInfo?.hideEquipment})} />
                  <label className="left-margin" htmlFor="schedule-status">
                      Hide Channels with No Equipment Configured
                  </label>
                </div>
            </div>
            {isSu&&
              <div className="checkbox-field float-left-box" style={{float:'none'}}>
                <div>
                  <input type="checkbox" id="DoserZone" checked={zoneInfo?.doserZone||false}
                    onChange={()=>this.onChange("doserZone", {doserZone:!zoneInfo?.doserZone})} />
                    <label className="left-margin" htmlFor="DoserZone">
                        Doser Zone
                    </label>
                  </div>
              </div>
            }
            <br />
            {((!current)||virtual)&&
              <>
                <button type="button" className="outlined clearfloat danger"
                onClick={()=>this.onChange("deleteZone")}>Delete Zone</button>
                <div className="clearfloat"></div><br/>
              </>
            }

          </>
        }
        <div className="clearfloat"></div>
        {acctFeature("virtualZones")&&this.showAddZone()}
        {acctFeature("moveZone")&&this.showMoveZone()}
      </div>
    )
    }else{
      return <LoadingSpinner message="Loading..." />
    }
  }
}
      
export default C18ManageZones;
